// extracted by mini-css-extract-plugin
module.exports = {"action":"style_action__3dm90","primary":"style_primary__2O5DO","secondary":"style_secondary__aqYrw"};